function navigateTo(url) {
    if (typeof window === 'undefined' || !url) {
        return;
    }
    window.location.assign(url);
}

export default navigateTo;
